import comp from "./SlickSlider";
export default comp;
